<!-- Copyright (C) 2025 Skylark Drones -->

<template>
  <v-dialog content-class="rounded-lg" persistent :value="true" width="400">
    <v-card>
      <v-card-title class="primary-font-color--text">
        {{ title }}
      </v-card-title>
      <v-text-field
        :value="value"
        @input="$emit('input', $event)"
        clearable
        autofocus
        class="mx-4 mt-2"
        dense
        counter="50"
        :label="textFieldLabel"
        outlined
        maxLength="50"
        @keydown.enter="isValueInvalid ? null : $emit('update')"
      />
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="loading"
          rounded
          text
          width="100"
          @click="$emit('close')"
        >
          Cancel
        </v-btn>
        <v-btn
          class="primary"
          rounded
          depressed
          :disabled="isValueInvalid"
          :loading="loading"
          @click="$emit('update')"
        >
          {{ ctaText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const EDIT_MODE = {
  CALL_SIGN: 'call_sign',
  LOCATION: 'location'
}

export default {
  name: 'DockActionsDialog',

  props: {
    dock: { type: Object },
    editMode: { type: String, required: true },
    loading: { type: Boolean, required: true },
    value: { type: String, required: true }
  },

  computed: {
    textFieldLabel() {
      return this.editMode === EDIT_MODE.CALL_SIGN
        ? 'Dock Callsign'
        : 'Location'
    },
    title() {
      return this.editMode === EDIT_MODE.CALL_SIGN
        ? 'Update Dock Callsign'
        : 'Update Location'
    },
    ctaText() {
      return this.editMode === EDIT_MODE.CALL_SIGN
        ? 'Update Dock Callsign'
        : 'Update Location'
    },
    isValueInvalid() {
      return !this.$props.value || !this.$props.value.trim()
    }
  }
}
</script>
